<template>
    <BasicPopup title="Saya ada siaran langsung gratis" :visible="visible" @close="handleClose">
        <div class="container">
            <div class="input-field">
                <input v-model="inputVal" class="input" type="text" placeholder="Silakan masukan" />

                <button class="submit-btn" :class="{ disabled: !inputVal }" :disabled="!inputVal" @click="handleSubmit">
                    Memasuki
                </button>
            </div>

            <p class="note">Tampilan sumber langsung setelah ditinjau</p>
        </div>
    </BasicPopup>
</template>

<script>
import BasicPopup from './BasicPopup.vue'

export default {
    components: {
        BasicPopup
    },

    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            inputVal: ''
        }
    },

    watch: {
        visible() {
            this.inputVal = ''
        }
    },

    methods: {
        handleClose() {
            this.$emit('close')
        },

        handleSubmit() {
            if (!this.inputVal) return

            this.$emit('submit', this.inputVal)
        }
    }
}
</script>

<style lang="less" scoped>
* {
    box-sizing: border-box;
}

.container {
    width: 100%;

    .input-field {
        display: flex;
        align-items: center;
        height: 2.0625rem;
        margin-bottom: 0.5625rem;

        .input {
            flex: 1;
            height: 100%;
            padding: 0.5625rem 0.5rem;
            border: 1px solid #ccc;
            border-radius: 0.3125rem;
            /* 去除获取焦点时的默认样式 */
            outline: none;
            box-shadow: none;
        }

        .submit-btn {
            margin-left: .625rem;
            height: 100%;
            padding: 0 .6875rem;
            font-size: 0.9375rem;
            font-weight: 500;
            color: #FFFFFF;
            border: none;
            border-radius: 0.0625rem;
            background: #16B13A;
            -webkit-tap-highlight-color: transparent;

            &.disabled {
                opacity: 0.8;
            }
        }
    }

    .note {
        text-align: center;
        font-size: 0.625rem;
        font-weight: 400;
        color: #8C969F;
        font-family: SF UI Display;
    }
}
</style>



// WEBPACK FOOTER //
// AppLivePopup.vue?864c4848